module.exports = __webpack_public_path__ + "static/colgadas-009-58c5ce5a8e64ca6bcd945dd1d9899a25.jpg";